import { defaultTheme } from 'gd-design-library';
import { colors } from './colors';

export const modal = {
  ...defaultTheme.modal,
  body: {
    ...defaultTheme.modal.body,
    default: {
      ...defaultTheme.modal.body.default,
      overflowY: 'auto',
      flex: 1
    }
  },
  content: {
    ...defaultTheme.modal.content,
    default: {
      ...defaultTheme.modal.content.default,
      maxHeight: '100vh'
    }
  },
  icons: {
    ...defaultTheme.modal.icons,
    close: {
      ...defaultTheme.modal.icons.close,
      color: colors.neutral.black
    }
  },
  overlay: {
    ...defaultTheme.modal.overlay,
    default: {
      ...defaultTheme.modal.overlay.default,
      height: '100dvh'
    }
  }
};
